import { render, staticRenderFns } from "./VenueLabelTable.vue?vue&type=template&id=ca32ff7a"
import script from "./VenueLabelTable.vue?vue&type=script&lang=ts"
export * from "./VenueLabelTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports